import { InstagramIcon } from '@/features/social-accounts/components/instagram-icon';
import { XIcon } from '@/features/social-accounts/components/x-icon';
import type { SocialAccountSourceIconProps } from '@/features/social-accounts/types/components';

export function SocialAccountSourceIcon({ source, className }: SocialAccountSourceIconProps) {
    switch (source) {
        case 'instagram':
            return <InstagramIcon className={className} />;
        case 'x':
            return <XIcon className={className} />;
        default:
            return null;
    }
}
